import {batch} from 'react-redux';
import {setAlert} from '../actions/alertModalStateAction';
import {logout, setSwVersion} from '../actions/appStateAction';
import {ALERT_VARIANT, COOKIE_AUTHTOKEN, EPathname, LOCALSTORAGE, RestApiMethod} from '../../const/dataEnum';
import {deleteLocalStorage, getLocalStorage} from '../../lib/localStorageHelper';
import {deleteCookie} from '../../lib/cookieHelper';
import {callAPI} from '../../api/rest/callApi';
import {API_SOFTWARE_VERSION} from '../../const/Api';
import {MenuData} from '../../components/MenuBar/MenuData';

export const sessionExpired = () => (dispatch) => {
  batch(() => {
    dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: 'Your session has expired'}));
    deleteLocalStorage(LOCALSTORAGE.COOKIE_EXPIRES);
    deleteCookie(COOKIE_AUTHTOKEN);
    dispatch(logout());
  });
};

export const getCookieRemainingTime = () => {
  const cookieExpires = getLocalStorage(LOCALSTORAGE.COOKIE_EXPIRES);
  if (cookieExpires) {
    const localTime = new Date(cookieExpires).toLocaleString();
    const oneMinuteMillisecond = 60000;
    const remainingTime = new Date(localTime) - new Date() - oneMinuteMillisecond;
    return remainingTime;
  }
  return 0;
};

/**
 * get config in public directory
 * @returns config
 */
export const getConfig = async (dispatch) => {
  const res = await fetch('/config.json');
  if (res) {
    const config = await res.json();
    return config;
  }
  dispatch(
    setAlert({
      show: true,
      variant: ALERT_VARIANT.ERROR,
      message: 'Failed to get config',
    })
  );
  return null;
};

export const getSwVersion = async (dispatch) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_SOFTWARE_VERSION,
    });
    const trimmedVersion = res.data ? res.data.slice(0, 5) : '';
    dispatch(setSwVersion(trimmedVersion));
  } catch (error) {
    console.error('getSwVersion Error:', error.message);
  }
};

export const getPathByMenuId = (menuId) => {
  const menu = MenuData.find((md) => md.id === menuId);
  if (menu) {
    return menu.path;
  }
  return null;
};

export const getPageTitleByMenuId = (pathname) => {
  switch (pathname) {
    case EPathname.REVIEW_QUESTION:
      return 'Review Question';
    case EPathname.CONSOLIDATION_REVIEW:
      return 'Consolidation Review';
    case EPathname.CONSOLIDATION_VIEW:
      return 'Consolidation View';
    case EPathname.MESSAGE_INBOX_USER:
      return 'Message';
    default: {
      const menu = MenuData.find((md) => md.path === pathname);
      if (menu) {
        return menu.pageTitle;
      }
      return null;
    }
  }
};

export const getMenuIdByPathname = (pathname) => {
  const menu = MenuData.find((md) => md.path === pathname);
  if (menu) {
    return menu.id;
  }
  return null;
};
